// db/db_helper.js
import { dbPromise } from "./index";
import { emitDbChange } from "./dbEvents";
import { getWorkspaceId } from "../Helper/workspaceStorage"
import PeerConnectionManager from "../Services/PeerConnectionManager";

const REQUEST_TIMEOUT_MS = 5000;
const pendingRequests = new Map();

PeerConnectionManager.onMessage(({ data } = {}) => {
    if (!data || data.type !== "get_response" || !data.requestId) return;

    const pending = pendingRequests.get(data.requestId);
    if (!pending) return;

    clearTimeout(pending.timeoutId);
    pending.timeoutId = setTimeout(() => {
        pendingRequests.delete(data.requestId);
        pending.reject(new Error(`Timeout beim Warten auf Host-Antwort für "${pending.store}"`));
    }, REQUEST_TIMEOUT_MS);

    const { batchIndex, totalBatches, data: chunk } = data;

    if (totalBatches === undefined) {
        clearTimeout(pending.timeoutId);
        pendingRequests.delete(data.requestId);
        pending.resolve(chunk);
        return;
    }

    pending.chunks[batchIndex] = chunk;
    pending.receivedCount += 1;

    if (pending.receivedCount === totalBatches) {
        clearTimeout(pending.timeoutId);
        pendingRequests.delete(data.requestId);
        const merged = pending.chunks.flat();
        pending.resolve(merged);
    }
});

function hostData(store, type = "get", data = null) {
    const requestId = crypto.randomUUID();

    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            pendingRequests.delete(requestId);
            reject(new Error(`Timeout beim Warten auf Host-Antwort für "${store}"`));
        }, REQUEST_TIMEOUT_MS);

        pendingRequests.set(requestId, {
            resolve,
            reject,
            timeoutId,
            store,
            chunks: [],
            receivedCount: 0,
        });

        PeerConnectionManager.send({
            type,
            store,
            requestId,
            data,
        });
    });
}

export const saveData = async (object, data) => {
    const id = await getWorkspaceId()
    if(id === null){return}
    if (id === "local") {
        PeerConnectionManager.send({
            type: "save",
            store: object,
            data
        });
    } else {
        const db = await dbPromise;
        await db.put(object, data, id);
        emitDbChange(object, id);
    }
};

export const getData = async (object) => {
    const id = await getWorkspaceId()
    if(id === null){return}
    if (id === "local") {
        try {
            return await hostData(object);
        } catch (err) {
            console.error("Fehler beim Abrufen vom Host:", err);
            return null;
        }
    } else {
        const db = await dbPromise;
        return await db.get(object, id);
    }
};

export const clearData = async (object) => {
    const id = await getWorkspaceId()
    if(id === null){return}
    if (id === "local") {

    } else {
        const db = await dbPromise;
        await db.delete(object, id);
        emitDbChange(object, id);
    }
};

export const findByID = async (object, id) => {
    const data = await getData(object) || []
    return data.find(i => i.id === id)
}

export const findByOfflineID = async (object, id) => {
    const data = await getData(object) || []
    return data.find(i => i.offlineId === id)
}

export const findByUser = async (object, code) => {
    const data = await getData(object)
    return Array.isArray(data) ? data.find(i => i?.user?.numberCode === code) : null
}

export const customFind = async (object, findRequest) => {
    const data = await getData(object)
    return Array.isArray(data) ? data.find(i => findRequest(i)) : null
}